import React from 'react';
import './App.css';
import twitter from './twitter2.png';
import tiktok from './tiktok2.png';
import utube from './utube.png';
const Footer = () => {
  return (
    <footer className="footer">
      <div className="socialLinks">
        <a href="https://x.com/18treellc" target="_blank" rel="noopener noreferrer">
          <img src={twitter} alt="twitter" width={55} height={55} />
        </a>
        <a href="https://www.youtube.com/@TorahLearn" target="_blank" rel="noopener noreferrer">
          <img src={utube} alt="utube" width={55} height={55} />
        </a>
        <a href="https://www.tiktok.com/@kohengodol" target="_blank" rel="noopener noreferrer">
          <img src={tiktok} alt="tiktok" width={55} height={55} />
        </a>
      </div>
    </footer>
  );
};
export default Footer;

